import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import useTranslate from '@sprinx/react-globalize/useTranslate';
import AppBarAction from '@sprinx/react-mui-layout/AppBarAction';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import useShoppingCartContent from '../useShoppingCartContent';
import AppBarActionCartIconButton from './AppBarActionCartIconButton';
import AppBartActionCartListItem from './AppBartActionCartListItem';

function AppBarActionCart(_ref) {
  var label = _ref.label,
      _ref$IconComponent = _ref.IconComponent,
      IconComponent = _ref$IconComponent === void 0 ? ShoppingCartIcon : _ref$IconComponent,
      IconComponentProps = _ref.IconComponentProps,
      rest = _objectWithoutProperties(_ref, ["label", "IconComponent", "IconComponentProps"]);

  var t = useTranslate();

  var _useShoppingCartConte = useShoppingCartContent(),
      _useShoppingCartConte2 = _slicedToArray(_useShoppingCartConte, 1),
      cart = _useShoppingCartConte2[0];

  var subjectsCount = React.useMemo(function () {
    return ((cart || {}).subjects || []).length;
  }, [cart]);
  return /*#__PURE__*/React.createElement(AppBarAction, _extends({}, rest, {
    icon: /*#__PURE__*/React.createElement(IconComponent, IconComponentProps),
    label: label || t('shoppingCart/components/appBartActionCart'),
    renderStandalone: function renderStandalone(provPros) {
      return /*#__PURE__*/React.createElement(AppBarActionCartIconButton, _extends({}, provPros, {
        subjectCount: subjectsCount
      }));
    },
    renderMenuItem: function renderMenuItem(provPros) {
      return /*#__PURE__*/React.createElement(AppBartActionCartListItem, _extends({}, provPros, {
        subjectCount: subjectsCount
      }));
    }
  }));
}

process.env.NODE_ENV !== "production" ? AppBarActionCart.propTypes = {
  /**
   * Ikona, ktera se ma zobrazit jako kosik
   */
  IconComponent: PropTypes.elementType,

  /**
   * Custom label. Poduk neni poskytnut bude pouzity preklad `app/actions/search`.
   */
  IconComponentProps: PropTypes.shape({}),
  label: PropTypes.string,

  /**
   * Cesta pro presmerovani po kliknuti.
   */
  path: PropTypes.string.isRequired,

  /**
   * Podminene zobrazeni vysledku.
   *
   * Pokud je hodnota `false`, nebo vysledek volani funkce je `false`,
   * komponenta se nebude zobrazovat.
   *
   * Funkce ma format `(showIfContext) => bool`.
   */
  showIf: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.func]),
  // eslint-disable-line react/no-unused-prop-types

  /**
   * Variant zobrazeni.
   *
   * - `none` nezobrazuje se.
   * - `standalone` aplikuje se renderStandalone pokud je definovano, nebo se renderuje IconButton.
   * - `menuItem` aplikuje se renderMenuItem pokud je definovano, nebo se renderuje MenuItem.
   */
  variant: PropTypes.oneOf(['none', 'standalone', 'menuItem'])
} : void 0;
AppBarActionCart.defaultProps = {
  IconComponent: undefined,
  IconComponentProps: undefined,
  label: undefined,
  showIf: true,
  variant: undefined
};
export default AppBarActionCart;